import React, { useEffect, useRef, useState } from "react";
import image1 from "./assets/investors/image1.webp";
import image2 from "./assets/investors/image2.webp";
import image3 from "./assets/investors/image3.webp";
import image4 from "./assets/investors/image4.webp";
import image5 from "./assets/investors/image5.webp";
import image6 from "./assets/investors/image6.webp";
import image7 from "./assets/investors/image7.webp";
import image8 from "./assets/investors/image8.webp";
import image9 from "./assets/investors/image9.webp";
import image10 from "./assets/investors/image10.webp";
import image11 from "./assets/investors/image11.webp";
import image12 from "./assets/investors/image12.webp";


const images = [
  image1, image2, image3, image4, image5, image6,
  image7, image8, image9, image10, image11, image12
];

const InfiniteCarousel: React.FC = () => {
  const trackRef = useRef<HTMLDivElement>(null);
  const animationRef = useRef<number>(0);
  const lastTimestamp = useRef<number>(0);
  const [paused, setPaused] = useState(false);
  const [position, setPosition] = useState(0); // current translateX in px

  const speed = 100; // px per second

  useEffect(() => {
    const animate = (timestamp: number) => {
      if (!lastTimestamp.current) lastTimestamp.current = timestamp;
      const delta = timestamp - lastTimestamp.current;
      lastTimestamp.current = timestamp;

      if (!paused && trackRef.current) {
        let nextPosition = position - (delta / 1000) * speed;

        const totalWidth = trackRef.current.scrollWidth / 2; // because images are duplicated
        if (Math.abs(nextPosition) >= totalWidth) {
          nextPosition = 0;
        }

        setPosition(nextPosition);
        trackRef.current.style.transform = `translateX(${nextPosition}px)`;
      }

      animationRef.current = requestAnimationFrame(animate);
    };

    animationRef.current = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(animationRef.current!);
  }, [paused, position]);

  return (
    <div
      className="overflow-hidden py-8"
      onMouseEnter={() => setPaused(true)}
      onMouseLeave={() => setPaused(false)}
    >
      <div ref={trackRef} className="flex w-max space-x-8 px-4 will-change-transform">
        {[...images, ...images].map((src, i) => (
          <div key={i} className="flex-none">
            <img
              src={src}
              alt={`investor-logo-${i}`}
              className="h-20 object-contain"
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default InfiniteCarousel;
